import {TablePanels} from '@Components/poster-editor/components/poster-editing-side-panel/components/poster-editing-table-options/poster-editing-table-options.types';
import {useEffect} from 'react';
import {LayoutBackgroundTypes} from '@PosterWhiteboard/items/layouts/layout.types';
import {BorderType} from '@PosterWhiteboard/classes/item-border.class';
import {useGetKeyFromTableItem} from '@Hooks/poster-editor/useGetKeyFromTableItem';
import {useGetKeyFromBorderOfActiveItem} from '@Hooks/poster-editor/useGetKeyFromBorderOfActiveItem';
import {useGetKeyFromTextStylesActiveItem} from '@Hooks/poster-editor/useGetKeyFromTextStylesActiveItem';

export function useIsOpenedTablePanelValid(currentlyOpenedPanel: TablePanels, setCurrentlyOpenedPanel: (newVal: TablePanels) => void): void {
  const backgroundType = useGetKeyFromTableItem('backgroundType');
  const solidBorderType = useGetKeyFromBorderOfActiveItem('solidBorderType');
  const stroke = useGetKeyFromTextStylesActiveItem('stroke');

  useEffect((): void => {
    if (backgroundType === LayoutBackgroundTypes.NONE && currentlyOpenedPanel === TablePanels.BACKGROUND) {
      setCurrentlyOpenedPanel(TablePanels.NONE);
    }
  }, [backgroundType]);

  useEffect((): void => {
    if (solidBorderType === BorderType.NONE && currentlyOpenedPanel === TablePanels.BORDER) {
      setCurrentlyOpenedPanel(TablePanels.NONE);
    }
  }, [solidBorderType]);

  useEffect((): void => {
    if (!stroke && currentlyOpenedPanel === TablePanels.OUTLINE) {
      setCurrentlyOpenedPanel(TablePanels.NONE);
    }
  }, [stroke]);

  return;
}
